import { HttpParams } from '@angular/common/http';

export function toHttpParams(model: any): { [key: string]: string | string[] } {

    const params: { [key: string]: string | string[] } = {};
    if (!model) {
        return params;
    }


    for (const key in model) {
        const val = model[key];
        if (val === undefined || val === null || val === '') continue;
        if (Array.isArray(val)) {
            if (val.length == 0) continue;
            params[key] = val.map(v => `${v}`);
        }
        else if (val instanceof Date) {
            params[key] = val.toISOString();
        }
        else {
            params[key] = `${val}`;
        }
    }
    return params;
    // Object.keys(model).forEach(key => {
    //     const val = model[key];
    //     if (val === undefined || val === null || val === '') return;
    //     if (Array.isArray(val)) {
    //         if (val.length == 0) return;
    //         params[key] = val.map(v => `${v}`);
    //     }
    //     else {
    //         params[key] = `${val}`;
    //     }

    // });

}
export function urlSplicing(url: string, obj: object) {
    if (url.indexOf('?') == -1) {
        url += '?'
    }
    Object.keys(obj).map((key) => {
        url += key + '=' + obj[key] + '&';
    })
    url = url.slice(0, url.length - 1)
    return url
}